import { useState } from 'react';
import { ButtonIcon, Text, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiErrorWarningLine } from '@remixicon/react';
import type { SpendFreshness } from '@internal/plugin-ai-spend-monitor-common';

export const SpendWarning = ({ freshness }: { freshness?: SpendFreshness }) => {
  const [open, setOpen] = useState(false);
  if (!freshness || freshness.status === 'fresh') return null;
  const explanation = `${
    freshness.status === 'unavailable'
      ? 'Unavailable: no successful value for this month.'
      : 'Stale: showing the last known value.'
  } ${freshness.error ?? 'Collection failed.'} Last successful update: ${
    freshness.lastSuccessfulAt
      ? new Date(freshness.lastSuccessfulAt).toUTCString()
      : 'never'
  }`;
  return (
    <TooltipTrigger
      isOpen={open}
      onOpenChange={setOpen}
      delay={0}
      closeDelay={0}
    >
      <ButtonIcon
        size="small"
        variant="tertiary"
        icon={
          <Text as="span" color="danger">
            <RiErrorWarningLine size={16} />
          </Text>
        }
        aria-label={explanation}
        onPress={() => setOpen(true)}
      />
      {/* Keep the portaled tooltip accessible when its trigger is inside a modal. */}
      <Tooltip data-react-aria-top-layer>{explanation}</Tooltip>
    </TooltipTrigger>
  );
};

export const SpendValue = ({
  value,
  freshness,
}: {
  value: string;
  freshness?: SpendFreshness;
}) => (
  <>
    {freshness?.status === 'unavailable' ? 'Unavailable' : value}
    <SpendWarning freshness={freshness} />
  </>
);
